module.exports = __webpack_public_path__ + "img/icon_task.881c2d4c.png";